import React from 'react';

/* eslint-disable max-len */
export default {
  line1a: {
    label: 'Full legal name*',
    hint: 'Enter the Full Legal Name of Entity/Branch.'
  },
  line1b: {
    label: <span>Country of incorporation/organisation <sup>*</sup></span>,
    hint: 'If you are a corporation, enter your country of incorporation. If you are another type of entity, enter the country under whose laws you are created, organized, or governed.'
  },
  line1c: {
    label: <span>Residence address: Address line <sup>1</sup>*</span>,
    hint: 'Enter the permanent residence address of the entity identified in line 1. Your permanent residence address is the address in the country where the entity claims to be a resident for purposes of that country’s income tax. Do not show the address of a financial institution (unless you are a financial institution providing your own address), a post office box, or an address used solely for mailing purposes unless it is the only address used by the entity and such address appears in the entity’s organizational documents (i.e., your registered address). If you do not have a tax residence in any country, the permanent residence address is where you maintain your principal office.'
  },
  line1d: {
    label: 'Mailing address: Address line',
    hint: 'Enter your mailing address only if it is different from the permanent Residence address you entered.'
  },
  line2a: {
    hint: <span>
      For federal tax purposes, you are considered a U.S. person if you are:
      <ul>
        <li>An individual who is a U.S. citizen or U.S. resident alien;</li>
        <li>A partnership, corporation, company, or association created or organized in the United States or under the laws of the United States;</li>
        <li>An estate (other than a foreign estate); or</li>
        <li>A domestic trust (as defined in Regulations section 301.7701-7).</li>
      </ul>
    </span>
  },
  'line2a US TIN': {
    hint: <span>
      If you have a social security number (SSN), enter it here. To apply for an SSN, get Form SS-5 from a Social Security Administration (SSA) office or online at www.ssa.gov/forms/ss-5.pdf.
      If you are in the United States, you can call the SSA at 1-800-772-1213. If you do not have an SSN and are not eligible to get one, you can get an individual taxpayer identification number (ITIN). To apply for an ITIN, file Form W-7 with the IRS. It usually takes 4–6 weeks to get an ITIN.
      A partner in a partnership conducting a trade or business in the United States will likely be allocated effectively connected taxable income. The partner is required to file a U.S. federal income tax return and must have a U.S. taxpayer identification number (TIN).
    </span>,
    caution: 'An ITIN is for tax use only. It does not entitle you to social security benefits or change your employment or immigration status under U.S. law.'
  },
  lineCountryOfTaxResidence: {
    hint: 'Enter the Country where the Account Holder is a Tax Resident. If you have populated 2a and identify as a U.S. person - make sure you populate one of the sections in Part 3 with the details of the Account Holder\'s U.S. tax residency.'
  },
  lineResidenceAddress: {
    hint: 'Make sure that the Residence address is provided corresponds to the Country of Tax Residence that was populated for this Controlling Person.'
  },
  lineTIN: {
    hint: 'Provide Account Holder\'s Tax Identification Number or Reason no TIN provided, taking into account the explanation A, B, and C above. '
  },
  'lineSigned Date': {
    label: <span>Date <sup>*</sup>:</span>,
    hint: 'Use the following format to input information about your signature date: DD-MM-YYYY. For example, if the signature date is April 15, 2022, you would enter 15-04-2022.'
  },
  line4a1: {
    label: 'FATCA',
    hint: 'Make sure you select only one FATCA classification and provide GIIN and additional information if applicable.'
  },
  line4a2: {
    label: 'CRS',
    hint: 'Make sure you select only one CRS classification and provide additional information if applicable.'
  },
  line4b: {
    hint: <span style={ { fontSize: '1.3rem' } }> <br />
      <strong>4b1 FATCA:</strong> Make sure you select only one FATCA classification and provide GIIN and additional information if applicable.<br />
      <strong>4b2 CRS:</strong> Make sure you select only one CRS classification and provide additional information if applicable.
    </span>
  },
  'line5.1a': {
    label: <span>First Name  <sup style={ { top: '-1em' } }> 5</sup></span>,
    hint: 'Please make sure to enter at least the first name and last name of the Controlling Person.'
  },
  'line5.1b': {
    label: <span>Country of Tax Residence <sup style={ { top: '-1em' } }> 5</sup></span>,
    hint: 'Enter the Country where the Controlling Person is a Tax Resident. If you have selected With U.S. Controlling Persons option - make sure you populate one of the sections in Part 3 with the details of the Account Holder\'s U.S. tax residency. '
  },
  'line5.1c': {
    label: <span style={ { fontSize: '1.5rem' } }>Residence address: Address line <sup style={ { top: '-1em' } }> 1 5</sup></span>,
    hint: 'Make sure that the Residence address that is provided corresponds to the Country of Tax Residence that was populated for this Controlling Person. '
  },
  'line5.1d': {
    label: 'Tax Identification Number',
    hint: 'Provide Controlling Person\'s Tax Identification Number or Reason no TIN provided, taking into account the explanation A, B, and C above. '
  },
  'line5.2a': {
    label: <span>First Name</span>,
    hint: 'Please make sure to enter at least the first name and last name of the Controlling Person.'
  },
  'line5.2b': {
    label: <span>Country of Tax Residence</span>,
    hint: 'Enter the Country where the Controlling Person is a Tax Resident. If you have selected With U.S. Controlling Persons option - make sure you populate one of the sections in Part 3 with the details of the Account Holder\'s U.S. tax residency. '
  },
  'line5.2c': {
    label: <span style={ { fontSize: '1.5rem' } }>Residence address: Address line <sup style={ { top: '-1em' } }> 1</sup></span>,
    hint: 'Make sure that the Residence address that is provided corresponds to the Country of Tax Residence that was populated for this Controlling Person. '
  },
  'line5.2d': {
    label: 'Tax Identification Number',
    hint: 'Provide Controlling Person\'s Tax Identification Number or Reason no TIN provided, taking into account the explanation A, B, and C above. '
  },
  'line5.3a': {
    label: <span>First Name</span>,
    hint: 'Please make sure to enter at least the first name and last name of the Controlling Person.'
  },
  'line5.3b': {
    label: <span>Country of Tax Residence</span>,
    hint: 'Enter the Country where the Controlling Person is a Tax Resident. If you have selected With U.S. Controlling Persons option - make sure you populate one of the sections in Part 3 with the details of the Account Holder\'s U.S. tax residency. '
  },
  'line5.3c': {
    label: <span style={ { fontSize: '1.5rem' } }>Residence address: Address line <sup style={ { top: '-1em' } }> 1</sup></span>,
    hint: 'Make sure that the Residence address that is provided corresponds to the Country of Tax Residence that was populated for this Controlling Person. '
  },
  'line5.3d': {
    label: 'Tax Identification Number',
    hint: 'Provide Controlling Person\'s Tax Identification Number or Reason no TIN provided, taking into account the explanation A, B, and C above. '
  },
  'line5.4a': {
    label: <span>First Name</span>,
    hint: 'Please make sure to enter at least the first name and last name of the Controlling Person.'
  },
  'line5.4b': {
    label: <span>Country of Tax Residence</span>,
    hint: 'Enter the Country where the Controlling Person is a Tax Resident. If you have selected With U.S. Controlling Persons option - make sure you populate one of the sections in Part 3 with the details of the Account Holder\'s U.S. tax residency. '
  },
  'line5.4c': {
    label: <span style={ { fontSize: '1.5rem' } }>Residence address: Address line <sup style={ { top: '-1em' } }> 1</sup></span>,
    hint: 'Make sure that the Residence address that is provided corresponds to the Country of Tax Residence that was populated for this Controlling Person. '
  },
  'line5.4d': {
    label: 'Tax Identification Number',
    hint: 'Provide Controlling Person\'s Tax Identification Number or Reason no TIN provided, taking into account the explanation A, B, and C above. '
  },
  'line5.5a': {
    label: <span>First Name</span>,
    hint: 'Please make sure to enter at least the first name and last name of the Controlling Person.'
  },
  'line5.5b': {
    label: <span>Country of Tax Residence</span>,
    hint: 'Enter the Country where the Controlling Person is a Tax Resident. If you have selected With U.S. Controlling Persons option - make sure you populate one of the sections in Part 3 with the details of the Account Holder\'s U.S. tax residency. '
  },
  'line5.5c': {
    label: <span style={ { fontSize: '1.5rem' } }>Residence address: Address line <sup style={ { top: '-1em' } }> 1</sup></span>,
    hint: 'Make sure that the Residence address that is provided corresponds to the Country of Tax Residence that was populated for this Controlling Person. '
  },
  'line5.5d': {
    label: 'Tax Identification Number',
    hint: 'Provide Controlling Person\'s Tax Identification Number or Reason no TIN provided, taking into account the explanation A, B, and C above. '
  },
  'line5.6a': {
    label: <span>First Name</span>,
    hint: 'Please make sure to enter at least the first name and last name of the Controlling Person.'
  },
  'line5.6b': {
    label: <span>Country of Tax Residence</span>,
    hint: 'Enter the Country where the Controlling Person is a Tax Resident. If you have selected With U.S. Controlling Persons option - make sure you populate one of the sections in Part 3 with the details of the Account Holder\'s U.S. tax residency. '
  },
  'line5.6c': {
    label: <span style={ { fontSize: '1.5rem' } }>Residence address: Address line <sup style={ { top: '-1em' } }> 1</sup></span>,
    hint: 'Make sure that the Residence address that is provided corresponds to the Country of Tax Residence that was populated for this Controlling Person. '
  },
  'line5.6d': {
    label: 'Tax Identification Number',
    hint: 'Provide Controlling Person\'s Tax Identification Number or Reason no TIN provided, taking into account the explanation A, B, and C above. '
  }
};
